export default __webpack_public_path__ + "static/media/cardspal_popup.4d2acb51.png";